



















import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'

export interface InputEditCollectionIcTagItem {
  icTagUid: string
}

export const defaultInputEditCollectionIcTagItem = (): InputEditCollectionIcTagItem => ({
  icTagUid: ''
})

@Component({
  components: {
    InputCode
  }
})
export default class CollectionEditCollectionIcTag extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: InputEditCollectionIcTagItem
}
